import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import * as moment from 'moment';

@Component({
  selector: 'app-reply-item',
  templateUrl: './reply-item.component.html',
  styleUrls: ['./reply-item.component.scss'],
  providers: [AngularFireDatabase],
})


export class ReplyItemComponent implements OnInit {
  @Input() reply;
  attachmentImage : any;
  attachmentFile : any;
  filename : any;

  profile : any = {
    avatarUrl: 'https://chispa-rural.firebaseapp.com/assets/img/avatar.png',
  }

  constructor(private db : AngularFireDatabase) { }

  ngOnInit() {
    const subscription = this.db.object(`profiles/${this.reply.userId}`)
    .valueChanges().subscribe(snapshot => {
      subscription.unsubscribe();
      Object.assign(this.profile, snapshot);

      if (this.reply.attachmentURL) {
        const file = this.getFileName();
        if (file.ext.match( /(jpg)|(jpeg)|(png)/ )) {
          this.attachmentImage = this.reply.attachmentURL;
        } else if (file.ext.match(/pdf/)) {
          this.attachmentFile = this.reply.attachmentURL;
          this.filename = file.filename;
        }
      }
    });
  }

  getFileName() {
    let name = this.reply.attachmentURL;
    name = name.replace('%2F', '/');
    name = name.split(/\/|%2F/).pop().replace(/\#(.*?)$/, '')
    .replace(/\?(.*?)$/, '');
    name = name.split('.');
    return {
      filename: (name[0] || ''),
      ext: (name[1] || '')
    }
  }

  openFile() {
    window.open(this.attachmentFile, '_blank');
  }

  getReplyDate() {
    moment.locale('es');
    let date = moment(this.reply.created_at);
    return date.format('DD MMM YYYY');
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/replies/reply-item/reply-item.component.ts